import axios from "const/axios";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "const/constants";

export async function syncCadPayments(cadId, payments) {
  const { data } = await axios.post(
    `${API_URL}/accounts/client-account-details/${cadId}/module-payments/sync`,
    payments
  );
  return data?.data ?? [];
}

export async function fetchModulePayments(cadId) {
  if (!cadId) return [];
  const { data } = await axios.get(
    `${API_URL}/accounts/client-account-details/${cadId}/module-payments`
  );
  return data?.data ?? [];
}

export function useModulePayments(cadId) {
  return useQuery({
    queryKey: ["modulePayments", cadId],
    queryFn: async () => {
      if (!cadId) return [];
      const { data } = await axios.get(
        `${API_URL}/accounts/client-account-details/${cadId}/module-payments`
      );
      return data?.data ?? [];
    },
    enabled: Boolean(cadId),
    staleTime: 0,
  });
}

export async function swapAdmissionTerms(cadId, { termA, termB }) {
  const { data } = await axios.post(
    `${API_URL}/accounts/client-account-details/${cadId}/terms/swap`,
    { termA, termB }
  );
  return data;
}

export async function getTermDeletePreview(cadId, termNumber) {
  const { data } = await axios.get(
    `${API_URL}/accounts/client-account-details/${cadId}/terms/${termNumber}/delete-preview`
  );
  return data?.data ?? data;
}

export async function forceDeleteAdmissionTerm(cadId, termNumber) {
  const { data } = await axios.delete(
    `${API_URL}/accounts/client-account-details/${cadId}/terms/${termNumber}`
  );
  return data;
}

export async function checkAndImportAdmissionTerm(admissionTermId) {
  const { data } = await axios.post(
    `${API_URL}/admission-terms/${admissionTermId}/check-and-import`
  );
  return data;
}

export async function importAdmissionTermForProvider(admissionTermId) {
  const { data } = await axios.post(
    `${API_URL}/admission-terms/${admissionTermId}/import-for-provider`
  );
  return data;
}

export async function setAdmissionTermPreImportAmounts(admissionTermId, amounts) {
  const { data } = await axios.patch(
    `${API_URL}/admission-terms/${admissionTermId}/pre-import-amounts`,
    amounts
  );
  return data;
}
